import React, { useState } from "react";
import { useGlobal } from "reactn";
import classnames from "classnames";
import { useLoginState, useFavorites } from "lib/hooks/userHooks";
import { ReactComponent as Heart } from "svg/heart.svg";

const FavoriteSummonerButton = (props) => {
  const [clientFavorites, setClientFavorites] = useGlobal("clientSummonerFavorites");
  const [updateFavorites, { data }] = useFavorites();
  const [isHovered, setIsHovered] = useState(false);
  const isLoggedIn = useLoginState();
  const { regionId, iconId, iconUrl, summonerName } = props;

  const checkIfFavorite = (summonerName) => {
    // Determine whether or not this summoner is in the above list.
    if (clientFavorites) {
      for (const element of clientFavorites) {
        if (element.summonerName === summonerName) {
          return true;
        }
      }
    }

    return false;
  };

  const sendRequest = (isFavorite) => {
    let currentFavoriteSummoners = clientFavorites;

    // Determine what the future favorite champions would look like, in either state.
    let favoriteSummoners = [];
    if (isFavorite) {
      currentFavoriteSummoners.forEach((element) => {
        if (element.summonerName !== summonerName) {
          favoriteSummoners.push({
            summonerName: element.summonerName,
            iconId: element.iconId,
            iconUrl: element.iconUrl,
            regionId: element.regionId,
          });
        }
      });
    } else {
      if (currentFavoriteSummoners) {
        favoriteSummoners = currentFavoriteSummoners.map((element) => {
          return {
            summonerName: element.summonerName,
            iconId: element.iconId,
            iconUrl: element.iconUrl,
            regionId: element.regionId,
          };
        });
      }
      favoriteSummoners.push({
        summonerName: summonerName,
        iconId: iconId,
        iconUrl: iconUrl,
        regionId: regionId,
      });
    }

    updateFavorites("summoners", favoriteSummoners);
  };

  if (!isLoggedIn || !clientFavorites) {
    return null;
  }

  const isFavorite = checkIfFavorite(summonerName);
  const buttonClassName = classnames("favorite-button", {
    "favorite-button_selected": isFavorite,
  });

  return (
    <div className={buttonClassName} onClick={() => sendRequest(isFavorite)}>
      <Heart className="favorite-button_icon" />
    </div>
  );
};

export default FavoriteSummonerButton;
